import React, { PureComponent } from "react";
import { Row, Col, TreeSelect } from 'antd';
import { Form, Input, Select, Upload, Message, Radio, Layout, Button } from 'element-react';
import "./opinionsMailbox.scss";
import { Link } from "react-router-dom";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
import img from "../../img/home/characteristic/img1.png";
import 'element-theme-default';

export default class opinionsMailbox extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        name: '',
        email: '',
        phoneNumber: '',
        idNumber: '',
        contactAddress: '',
        title: '',
        content: '',
      },

    };
  }

  componentDidMount() {
    const idVal = Request.GetUrlParam('id');//获取地址栏参数
    Http.get(Request.solicitopinionsDetail(), { "id": idVal }, obj => {
      console.log('solicitopinionsDetail---', obj)
      if (obj) {
        this.setState({
          form: obj.data
        })
      }
    });
  }


  render() {
    const { form } = this.state;

    return (
      <div className="complaint-container">
        <fieldset disabled>

          <Form ref="form" model={form} labelWidth="80" className="demo-ruleForm">
            <Row gutter={8}>
              <Col sm={{ span: 24 }} style={{ marginBottom: 24 }}>
                <span className="title">征求意见详情</span>
              </Col>
              {/* <Col sm={{ span: 24}} style={{marginBottom:24}}>
                <span className="SO_title1">欢迎您的到来！</span>
              </Col>
              <Col sm={{ span: 24}} style={{marginBottom:24}}>
                <span className="SO_title2">为了更好地服务退役军人，内蒙古自治区退役军人事务厅网站开通征求意见栏目，听取大家对退役军人事务工作的意见和建议，进一步提升服务质量和工作水平。我们的工作离不开大家的宝贵意见，您的每一条意见和建议，我们都会认真汇总整理，并进行专门研究，公开答复。如果是反映个人诉求，请到【网上信访】栏目，我们会有专人负责为您解决和答复，在这里留言不作应答。</span>
              </Col>
              <Col sm={{ span: 24}} style={{marginBottom:24}}>
                <span className="SO_title3">感谢您的支持和参与，谢谢！</span>
              </Col> */}
              <Col sm={{ span: 24 }}>
                <Col sm={{ span: 6 }}>
                  <Form.Item label="姓名" props="name">
                    <Input value={form.name}></Input>
                  </Form.Item>
                </Col>
              </Col>
              <Col sm={{ span: 12 }}>
                <Form.Item label="电子邮箱" props="email">
                  <Input value={form.email}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 12 }}>
                <Form.Item label="联系电话" props="phoneNumber">
                  <Input value={form.phoneNumber} ></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 12 }}>
                <Form.Item label="身份证号" props="idNumber">
                  <Input value={form.idNumber} ></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 12 }}>
                <Form.Item label="联系地址" props="contactAddress">
                  <Input value={form.contactAddress} ></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 24 }}>
                <Form.Item label="标题" props="title">
                  <Input value={form.title}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 24 }}>
                <Form.Item label="内容" props="content">
                  <Input
                    type="textarea"
                    resize='none'
                    value={form.content}
                  />
                </Form.Item>
              </Col>

            </Row>

          </Form>
        </fieldset>
      </div>
    );
  }
}
